import styled from "styled-components"

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const Title = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
`

export const Message = styled.span<{ $error?: boolean }>`
  font-size: 13px;
  line-height: 1.4;
  color: ${({ $error }) => ($error ? "#DC2626" : "#64748B")};
`

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Option = styled.button<{ $active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 12px 14px;
  border-radius: 10px;
  cursor: pointer;
  text-align: left;
  font-size: 14px;
  color: #0f172a;
  background: ${({ $active }) => ($active ? "rgba(0, 97, 230, 0.06)" : "#fff")};
  border: 1.5px solid
    ${({ $active, theme }) => ($active ? theme.colors.blue.main : "#E2E8F0")};

  small {
    font-size: 12.5px;
    color: #64748b;
    white-space: nowrap;
  }
`
